import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import EllipsisMenu       from 'app/components/common/ellipsis-menu';
import Icon               from 'app/components/common/icon';
import Link               from 'app/components/common/link';
import Meta               from 'app/components/common/meta';
import Pagination         from 'app/components/common/pagination';
import ScrollTable        from 'app/components/common/scroll-table';
import CadminLayout       from 'app/components/company-admin/layout/';
import PageLoading        from 'app/components/layout/page-loading';
import FormsDuck          from 'app/ducks/company-admin/forms';
import UiFormsDuck        from 'app/ducks/company-admin/ui-forms';
import formsHelpers       from 'app/helpers/forms';
import paths              from 'app/paths';
import CadminSlx          from 'app/selectors/company-admin/';

import Form               from 'app/components/forms/form';
import Builder            from 'app/components/company-admin/forms/builder';


class CadminPageFormsEdit extends React.PureComponent {

  constructor(props) {
    super(props);
  }

  render() {
    const {company, form} = this.props;
    if (!company || !form) return <PageLoading />;

    const builder = <Builder form={form} />;

    return (
      <CadminLayout className="ca-forms" company={company} activeItem="forms" builder={builder} dnd>
        <Meta title={`Edit Form | Millie`} />
        <Form form={form} company={company} editMode />
      </CadminLayout>
    );
  }

}

const stateToProps = (state) => ({
  company: CadminSlx.company(state),
  form: UiFormsDuck.Slx.pgEditForm(state),
});
const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(CadminPageFormsEdit);
